import {
  Typography, Checkbox,
  Table, TableBody, TableHead, TableRow, TableCell
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { SettingsContainer } from './BranchComponents';

import { colors } from '../../../healtheraComponents';
import Spinner from '../../Shared/Spinner';

import { getDeliveryOptions } from '../../../redux/delivery-options';
import { getOrderTypes } from '../../../redux/order-types';

const DeliveryOptions = ({ pharmacy, onChange }) => {
  const dispatch = useDispatch();

  const [ initialized, setInitialized ] = useState(false);

  const { deliveryOptions } = useSelector(state => state.deliveryOptions);
  const { orderTypes } = useSelector(state => state.orderTypes);

  useEffect(() => {
    dispatch(getDeliveryOptions());
    dispatch(getOrderTypes());
  }, [dispatch]);

  useEffect(() => {
    if (!deliveryOptions?.length) return;
    if (!orderTypes?.length) return;

    setInitialized(true);
  }, [ deliveryOptions, orderTypes ]);

  function deliveryActivationHandler(deliveryOptionType, orderType) {
    return function(e) {
      onChange(`delivery_options.${deliveryOptionType}.${orderType}`, e.target.checked);
    };
  }

  function deliveryOptionChecked(pharmacy, deliveryOptionType, orderType) {
    return pharmacy.delivery_options?.[deliveryOptionType]?.[orderType] || false;
  }

  function deliveryChargeHandler(deliveryOptionType, orderType) {
    return function(e) {
      onChange(`charge_for_delivery.${deliveryOptionType}.${orderType}`, e.target.checked)
    };
  }

  function deliveryChargeChecked(pharmacy, deliveryOptionType, orderType) {
    return pharmacy.charge_for_delivery?.[deliveryOptionType]?.[orderType] || false;
  }

  function deliveryChargeDisabled(pharmacy, deliveryOptionType, orderType) {
    if (!pharmacy.delivery_options?.[deliveryOptionType]?.[orderType]) return true;

    return false;
  }

  return (
    <SettingsContainer>
      <Title>Delivery options</Title>

      {initialized ?
        <Table padding='none'>
          <TableHead>
            <TableRow>
              <TableCell style={{fontSize:16}}>Order type</TableCell>
              {deliveryOptions.map(option => {
                return <TableCell
                  style={{textAlign: 'center', width: '21%', fontSize:16 }}
                  key={option.type}>
                  {option.pharmacy_label}
                  <br />
                  <Typography component="span">
                    {/delivery/i.test(option.type) ? 'activate | charge?' : 'activate' }
                  </Typography>
                </TableCell>;
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {orderTypes.map(order_type => {
              return (
                <TableRow key={order_type.type}>
                  <TableCell style={{fontSize:15}}>{order_type.name}</TableCell>
                  {deliveryOptions.map(option => {
                    return (
                      <TableCell style={{textAlign:'center'}} key={option.type}>
                        <Checkbox
                          onChange={deliveryActivationHandler(option.type, order_type.type)}
                          checked={deliveryOptionChecked(pharmacy, option.type, order_type.type)}>
                        </Checkbox>
                        {/delivery/i.test(option.type) &&
                          <Checkbox
                            onChange={deliveryChargeHandler(option.type, order_type.type)}
                            checked={deliveryChargeChecked(pharmacy, option.type, order_type.type)}
                            disabled={deliveryChargeDisabled(pharmacy, option.type, order_type.type)}>
                          </Checkbox>
                        }
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        : <Spinner />
      }

    </SettingsContainer>
  );
};

const Title = styled(Typography)`
  && {
    color: ${colors.DARK};
    font-size: 17px;
    font-weight: 600;
  }
`;

export default DeliveryOptions;
